<div class="confirm-dialog">
  <h2>{{ title }}</h2>
  <span>{{ description }}</span>
  <div class="confirm-dialog__actions">
    <ion-button size="small" (click)="onAccept()">{{ acceptText }}</ion-button>
    @if (cancelText) {
      <ion-button fill="outline" size="small" (click)="onCancel()">{{ cancelText }}</ion-button>
    }
  </div>
</div>
